import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { DigitalEquipment } from "src/app/models";
import { SnackBarService } from "src/app/services/snackbar.service";

@Component({
	selector: "dr-digital-equipment-form",
	templateUrl: "./digital-equipment-form.component.html",
	styleUrls: ["./digital-equipment-form.component.scss"],
})
export class DigitalEquipmentFormComponent implements OnInit, OnChanges {
	@Input() public canEditDigitalEquipment!: boolean;
	@Input() allDigitalEquipments!: Map<string, DigitalEquipment>;
	@Input() assetIdToShow: number | undefined;
	@Input() cssClass!: string;
	@Output() digitalEquipmentChanged = new EventEmitter<string>();
	public digitalEquipmentFormGroup: FormGroup;
	public digitalEquipmentControl: FormControl;

	constructor(
		private readonly formBuilder: FormBuilder,
		private readonly snackbarService: SnackBarService,
		private readonly translateService: TranslateService,
	) {
		this.digitalEquipmentFormGroup = this.formBuilder.group({});
		this.digitalEquipmentControl = this.formBuilder.control<string>("");
	}

	public ngOnChanges(changes: SimpleChanges): void {
		const currentAssetIdToShow: number = changes["assetIdToShow"]?.currentValue;
		const previousAssetIdToShow: number = changes["assetIdToShow"]?.previousValue;
		if (!!currentAssetIdToShow && currentAssetIdToShow != previousAssetIdToShow) {

			this.digitalEquipmentControl.patchValue(this.assetIdToShow, { emitEvent: false });
		}
	}
	ngOnInit(): void {
		this.digitalEquipmentFormGroup.addControl("digitalEquipmentControl", this.digitalEquipmentControl);

		if (!!this.assetIdToShow) {
			this.digitalEquipmentControl.patchValue(this.assetIdToShow, { emitEvent: false });
		}

		this.digitalEquipmentControl.valueChanges.subscribe((value) => {
			//Remove nonnumeric values
			this.digitalEquipmentControl.patchValue(value?.replace(/[^0-9]/g, ""), { emitEvent: false });
			if (value.length == 0) {
				this.digitalEquipmentChanged.emit(undefined);
			}
			//Allow only 6 digits
			if (value.length > 5) {
				this.digitalEquipmentControl.patchValue(value.substring(0, 5) as string, { emitEvent: false });
			}
			//update currentDigitalEquipmentFromUser (that will be shown in the map)
			if (value.length == 5) {
				const str = value.toString();
				const formatedStr = `${str.slice(0, 3)}-${str.slice(3)}`;
				const existingDigitalEquipment: DigitalEquipment | undefined = this.allDigitalEquipments.get(formatedStr);
				if (existingDigitalEquipment) {
					this.digitalEquipmentChanged.emit(existingDigitalEquipment.assetId);
				} else {
					this.snackbarService.showError(this.translateService.instant("roadwork.equipment-does-not-exist", { assetId: formatedStr }));
				}
			}
		});
	}
}
